<template>
  <div>
    <Form :label-width="100" inline>
      <FormItem label="质疑单位名称" required>
        <Input style="width:600px;" v-model="questionData.questionCompany"></Input>
      </FormItem>
      <FormItem label="收到时间" required>
        <!-- <Input style="width:200px;"></Input> -->
        <DatePicker type="date" placeholder="选择时间" style="width: 200px" @on-change="receiveTimeChange" v-model="questionData.receiveTime"></DatePicker>
      </FormItem>
      <FormItem label="答复时间">
        <!-- <Input style="width:200px;"></Input> -->
        <DatePicker type="date" placeholder="选择时间" style="width: 200px" @on-change="responseTimeChange" v-model="questionData.responseTime"></DatePicker>
      </FormItem>
      <FormItem label="回复文号">
        <Input style="width:200px;" v-model="questionData.replyNumber"></Input>
      </FormItem>
      <FormItem label="收到书面形式">
        <Input style="width:200px;" v-model="questionData.written"></Input>
      </FormItem>
      <FormItem label="质疑阶段">
        <Input style="width:200px;" v-model="questionData.questionStage"></Input>
      </FormItem>
      <FormItem label="处理结果">
        <Input style="width:200px;" v-model="questionData.results"></Input>
      </FormItem>
      <div>
        <FormItem label="是否有效">
          <Select style="width:80px;" v-model="questionData.isEnabled">
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
        <FormItem label="是否提交报告">
          <Select style="width:80px;" v-model="questionData.isSubmit">
            <Option value="是">是</Option>
            <Option value="否">否</Option>
          </Select>
        </FormItem>
      </div>
      <div>
        <FormItem label="电子文件">
          <Select style="width:80px;" v-model="questionData.electronicFiles">
            <Option value="有">有</Option>
            <Option value="无">无</Option>
          </Select>
        </FormItem>
        <FormItem label="纸质原件">
          <Select style="width:80px;" v-model="questionData.original">
            <Option value="有">有</Option>
            <Option value="无">无</Option>
          </Select>
        </FormItem>
      </div>
      <FormItem label="质疑点描述">
        <Input type="textarea" :autosize="true" style="width:600px;" v-model="questionData.describe"></Input>
      </FormItem>
      <FormItem label="质疑范畴">
        <Input style="width:600px;" v-model="questionData.category"></Input>
      </FormItem>
      <FormItem label="关联项目" required>
        <Input style="width:200px;margin-right:5px;" v-model="questionData.projectNum"></Input>
        <Button type="primary" size="small" @click="projectChoose">选择</Button>
      </FormItem>
    </Form>
    <!-- 项目关联选择 -->
    <Modal v-model="projectChooseVisible" title="关联选择" :transfer="false" width="800">
      <project-choose @endImport="importProject"></project-choose>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import ProjectChoose from '@/components/projectChoose'

export default {
  name: 'questionForm',
  components: {
    ProjectChoose
  },
  props: {
    selectRegister: {
      type: Object
    }
  },
  data() {
    return {
      questionData: {
        id: '',
        projectId: '',
        questionCompany: '',
        receiveTime: '',
        written: '',
        describe: '',
        questionStage: '',
        followUp: '',
        assistant: '',
        customer: '',
        responseTime: '',
        replyNumber: '',
        results: '',
        category: '',
        isEnabled: '',
        isSubmit: '',
        original: '',
        electronicFiles: '',
        projectNum: '',
      },
      projectChooseVisible: false
    }
  },
  methods: {
    projectChoose() {
      this.projectChooseVisible = true
    },
    importProject(project) {
      this.questionData.projectId = project.id
      this.questionData.projectNum = project.projectFull
      this.projectChooseVisible = false
    },
    getResult() {
      return this.questionData
    },
    receiveTimeChange(time) {
      this.questionData.receiveTime = time
    },
    responseTimeChange(time) {
      this.questionData.responseTime = time
    },
    clearRegister() {
      this.questionData = {
        id: '',
        projectId: '',
        questionCompany: '',
        receiveTime: '',
        written: '',
        describe: '',
        questionStage: '',
        followUp: '',
        assistant: '',
        customer: '',
        responseTime: '',
        replyNumber: '',
        results: '',
        category: '',
        isEnabled: '',
        isSubmit: '',
        original: '',
        electronicFiles: '',
        projectNum: '',
      }
    }
  },
  watch: {
    selectRegister(register) {
      if (register) {
        this.questionData = register
        this.questionData.projectNum = register.clProject.projectFull
      }
    }
  }
}
</script>
